import request, { CancelablePromise, download } from "../util/client";
import { ListParams, ListResponse } from "./types";

export interface StockData {
    area: number;
    row: number;
    col: number;
    sku: string;
    qty: number;
    status: number;
    created_at?: number;
    error?: boolean;
    newSku?: string;
    diff?: number;
}

export interface GridConfig {
    name?: string;
    rows: number;
    cols: number;
    disabled?: Array<string>;
    picking?: Array<number>;
}

export interface StockHistoryData {
    sku: string;
    qty: number;
    created_at: number;
    deleted_at: number;
}

export function getStock(sku: string): CancelablePromise<string | { data: Array<StockData>, map: string, config: Array<GridConfig> }>;
export function getStock(filter: { area?: number, row?: number, col?: number, sku?: string }): CancelablePromise<string | { data: Array<StockData>, map: string, config: Array<GridConfig> }>;
export function getStock(filter: { area?: number, row?: number, col?: number, sku?: string } | string): CancelablePromise<string | { data: Array<StockData>, map: string, config: Array<GridConfig> }> {
    return request('stock', 'GET', typeof filter === 'string' ? { sku: { like: '%' + filter + '%' }, limit: -1 } : filter);
}

interface getStockHistoryParmas {
    area?: number;
    row?: number;
    col?: number;
    page?: number;
    limit?: number;
}

export function getStockHistory(data: getStockHistoryParmas): CancelablePromise<ListResponse<StockHistoryData>>;
export function getStockHistory(position: [number, number, number], search: URLSearchParams): CancelablePromise<ListResponse<StockHistoryData>>;
export function getStockHistory(position: [number, number, number] | getStockHistoryParmas, search?: URLSearchParams) {
    let params: getStockHistoryParmas;
    if (Array.isArray(position)) {
        params = {
            area: position[0], row: position[1], col: position[2],
            page: parseInt(search?.get('page') || '1'),
            limit: parseInt(search?.get('limit') || '10')
        };
    } else {
        params = position;
    }
    return request<ListResponse<StockHistoryData>>('stock/history', 'GET', params);
}

export function stockOut(params: { position: Array<[number, number, number] | [number, number, number, string | number] | [number, number, number, string, number]> }) {
    return request<string>('stock', 'DELETE', params);
}

export function setStockStatus(params: { area: number, row: number, col: number, sku: string, status: number }) {
    return request<string>('stock', 'PATCH', params);
}

export interface ParamsStockIn {
    area: number;
    row: number;
    col: number;
    sku: Record<string, number>;
    created_at?: number;
}

export function stockIn(params: ParamsStockIn) {
    return request<{ [index: number | `${number}`]: Array<{ sku: string, position: Array<number> }>, error?: Array<{ sku: string, position: Array<number> }> }>('stock', 'PUT', params);
}

export function stockTransfer(from: [number, number, number, string, number, number], to: [number, number, number]) {
    return request<string>('stock', 'MOVE', { from, to });
}

export interface DispatchData {
    container_id: number;
    sku: string;
    qty: number;
    epcs: Array<string>
}

export function stockDispatch(container?: string) {
    return request<Array<DispatchData>>('stock/out', 'GET', container ? { filter: { container } } : '');
}

export function exportHistory(container: string | Array<string>) {
    return download('stock/out', 'POST', { container });
}

export interface ContainerData {
    id: number;
    code: string;
    order_id: string;
    info: any;
    status: number;
    created_at: number;
}

export function getContainer(params: ListParams<Partial<ContainerData>> | { entries: () => IterableIterator<[string, string]> }) {
    return request<ListResponse<ContainerData>>('container', 'GET', params);
}

export function getStockConfig(): CancelablePromise<Array<GridConfig>>;
export function getStockConfig(params: { status: 1 }): CancelablePromise<{ config: Array<GridConfig>, status: Array<StockData> }>;
export function getStockConfig(params?: { status: 1 }) {
    return request('stock/config', 'GET', params);
}

export interface StockCount {
    id: number;
    admin_id: number;
    adjustment?: string;
    lead: string;
    result: Array<StockData>;
    orders: Array<string>;
    filter: { group?: string[], sub_group?: string[] };
    status: number;
    created_at: number;
    updated_at: number;
}

export function getCountHistory(params: { page?: number, limit?: number }) {
    return request<ListResponse<StockCount>>('stock/count', 'GET', params);
}

export function saveCountResult(data: Pick<StockCount, 'result' | 'orders' | 'status' | 'adjustment' | 'filter'> & { id?: number, lead?: string }) {
    return request<{ msg: string, data: number }>('stock/count', 'POST', data);
}
